const leadPreferences = {
  leadPreferences: {
    pageHeader: 'リードの設定',
    confirmMessage: 'リードの設定を保存して、ユーザーの追加ページに進んでよろしいですか？',
    notInterested: {
      radioOptions0: '新規リードに対応する時間／リソースの不足',
      radioOptions1: '契約済みの住宅所有者にのみ興味がある',
      radioOptions2: '価格帯を開示したくない',
      radioOptions3: 'その他',
      selectReason: 'Enphase Leads Programをオプトアウトする理由を選択してください',
      otherComments: 'その他のコメント'
    },
    programOverview: {
      notInterestedText: '現在、Enphase Leads Programへの参加には興味がありません'
    },
    serviceDetailsSection: {
      min: '最小',
      max: '最大',
      maxLessMin: '最大値は最小値以下にはできません',
      enterInRange: '%{serviceMInValue} から%{serviceMaxValue} までの数字のみを入力してください',
      note: '注：',
      noteText:
        'この入力に基づき、住宅所有者に価格帯が表示されます。この価格には税金は含まれているが、インセンティブは含まれていません。',
      noteTextAus:
        'この入力に基づき、住宅所有者に価格帯が表示されます。この価格にはGSTが含まれているが、インセンティブは含まれていません。',
      sizeRange: 'サイズ範囲',
      pricePerkWh: 'kWhあたりの価格',
      lessThan20kWh: '20kWh未満',
      greaterThan20kWh: '20～40 kWh'
    },
    serviceAreaSection: {
      title: '管理者アクセスとサービスエリア',
      manageAdminAccess: '管理者アクセスの管理',
      addNewUser: '+ 新規ユーザーの追加',
      selectOneAdmin:
        'Enphaseがリードに関連するエスカレーションを貴社に連絡する際の唯一の連絡先となる、貴社の管理ユーザーを1名お選びください。',
      selectUser: 'ユーザーを選択',
      otherAdmin:
        '#上記のリストに含まれる他の管理ユーザーは、すべての新しいリードとその更新のアラートを引き続き受信します。必要であれば、通知設定を更新することでオフにすることができます。',
      serviceArea: 'サービスエリア',
      addServiceAreas: ''
    },
    addUserDialog: {
      yes: 'はい'
    },
    acModule: {
      optIn: 'Enphase Energized ACモジュール設置のオプトイン',
      description:
        '住宅所有者がACモジュールベースのシステムに興味を示します。ACモジュールを調達し、設置します。Enphase Energized ACモジュールは、Enphase の最新の最先端Microinverter技術と高効率ソーラーパネルを組み合わせたものです。インバーターとパネルを一体化することで設置時間を短縮し、美観と性能を兼ね備えたエレガントな製品です。'
    },
    sampleQuotes: {
      title: 'リードの参考価格',
      useSlider:
        '以下のスライダーを使用して、入力された価格帯が、さまざまなシステム・サイズの住宅所有者向け価格帯にどのように変換されるかをご確認ください。',
      description:
        '入力内容に基づき、住宅所有者に表示される参考価格帯がここに表示されます。また、システムサイズによって価格帯がどのように異なるかも確認できます。',
      solarOnly: 'ソーラーの設置',
      storageOnly: '蓄電池の設置',
      solarStorage: 'ソーラー＋蓄電池の設置',
      solarExpansion: 'ソーラーの拡張',
      turnkeyACM: '蓄電池の設置＋ACMアップグレード',
      microUpgrade: 'Microinverter Upgrade',
      turnkeyIQSeries: '蓄電池の設置＋マイクロインバータ Upgrade',
      installationACM: '蓄電池の設置＋ACMアップグレード',
      installationIQSeries: '蓄電池の設置＋マイクロインバータ Upgrade',
      installationSolar: 'ソーラーの設置',
      installationStorage: '蓄電池の設置/拡張',
      turnkeyNew: '新規住宅所有者向けターンキー価格',
      turnKeyExisting: '既存住宅所有者向けターンキー価格',
      turnkeyNewUS: '住宅所有者向けターンキー価格',
      installationUS: '住宅所有者向け設置のみの価格',
      installation: 'M-190 Microのお客様のための設置のみのお見積もり',
      turnkeyPrice: 'ターンキー価格',
      installation2: 'ご紹介者様への設置のみの価格',
      installation3: '設置のみの価格',
      microinverterFootnote: 'サイトの築年数により、Microinverter upgrade価格が追加される場合があります',
      solar: 'ソーラー',
      storage: '蓄電池'
    },
    operationMaintenance: {
      label: 'O&Mサービスのオプトイン',
      description:
        'オペレーションとメンテナンス (O&M) サービスには、既存のEnphaseシステムと、オーファンシステム (設置業者が今ではアクティブではないサイト) のサポートとメンテナンスが含まれます。すべてのO&Mリードには、サイトの詳細とサポート履歴が提供されます。すべての O&M リードには、Enphase 標準製品保証が適用されます。オーファンシステムには、以前の製造保証は適用されません。'
    },
    leadProgram: {
      optIn: 'Enphase Leads Programへのオプトイン',
      description:
        '住宅オーナーは、新規設置、アップグレード、継続的なシステムメンテナンスのために Enphase に連絡します。Enphaseのパートナーには、Enphase Leads Programを通じて、このような住宅所有者にサービスを提供する機会があります。',
      programHighlights: 'プログラムのハイライト：',
      keyTerms1: 'Enphase は、お客様のサービスエリアから適格なリードを無料で提供します',
      keyTerms2: '最初の交渉の前に、顧客プロファイルとプロジェクトの詳細を各リードに提供します',
      keyTerms3: 'Enphase は、スケジュール、予約、プロジェクトの更新、および技術サポートを支援します',
      keyTerms4: '設置業者には、2 営業日以内に各リードに対応、連絡し、見積もりを送付することが期待されています',
      keyTerms5: 'プログラムの一環として、Enphase製品のみを使用すること',
      leadProgramPreferences: 'リードプログラムの設定',
      someLeads:
        'リードによっては、設置サービスのみを必要とする場合もあります。そのようなリードのオプトインを希望される場合は、以下にご記入ください。',
      tooltipTitle1:
        '住宅オーナーに提供するサービス。Enphase は、選択されたサービスの環境設定に基づいて住宅オーナーを紹介します',
      turnKey: 'ターンキーサービス',

      tooltipTitle2: '貴社がすべての機器、設計、許可、設置サービスを提供します',
      installationService: '設置のみのサービス',
      tooltipTitle3:
        '住宅オーナーは、Enphase Storeから Enphase の機器を調達することを選択します。貴社は残りの設備、設計、許可、設置サービスを提供します',
      solarNew: 'ソーラー - 新規設置',
      solarUpgrades: 'ソーラー - アップグレード',
      storageNew: '蓄電池 - 新規設置'
    },
    textContent: {
      preference: {
        title: 'Leads Programの設定',
        caption: '免責事項',
        description:
          'Enphaseは、住宅所有者に対して、以下の各希望に対して提供された価格範囲を表示します。この価格設定は予算的なものであり、典型的なシステムの作業範囲のみを反映したものであるという免責事項とともに表示されます。実際の価格は、場所、屋根のタイプ/ピッチ、電気パネルのアップグレード、システムの別の場所への移設によって変更される場合があります。',
        atleaseOne: '* 少なくとも1つのサービスを選択'
      },
      programreview: {
        title: 'プログラム概要',
        description:
          '住宅オーナーは、新規設置、アップグレード、継続的なシステムメンテナンスのために Enphase に連絡します。Enphaseのパートナーには、Enphase Leads Programを通じて、このような住宅所有者にサービスを提供する機会があります。以下の主要条件をご確認の上、このプログラムに対するご希望をご指定ください。'
      },
      keyProgramTerms: {
        title: 'プログラムの主要条件',
        enphaseProduct: 'プログラムの一環として、Enphase製品のみを使用すること',
        appointment: 'Enphaseは、予約のスケジューリングをサポートし、必要に応じてその他のサポートを提供します',
        contact: '設置業者は、2営業日以内に各リードに連絡することが期待されています',
        project: '最初の交渉の前に、顧客プロファイルとプロジェクトの詳細を各リードに提供します',
        verifiedAccount: 'Enphase は、お客様のサービスエリアから適格なリードを無料で提供します'
      },
      TurnKey: {
        title: 'ターンキーサービス',
        description: `ターンキーサービスとは、設置業者がすべての部品表、設計、許可、設置、および試運転（該当する場合）を提供することを意味します。設置業者は、詳細な見積もりを提示する前に、プロジェクトと現場の査定を行います。表示価格には、システムを作動させるために住宅所有者が負担する見積もり費用の合計が含まれています。`,
        solar: {
          indicativePricing: '1ワットあたりの参考価格帯',
          quoteSizeIn: 'kW',
          main: 'ソーラー - 設置',
          sub: '新しいソーラーシステムの設置。',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub:
                'ターンキー価格を提供し、モジュール、マイクロインバータ（またはACモジュール）、IQ Combinerボックス、アクセサリーキット、サーキットブレーカー、セルラーモデム、ケーブル、架台など、必要なすべての部品表を調達します。'
            },
            assumptions: {
              main: '前提条件',
              sub: '価格帯は一般的な敷地のもので、メインパネルのアップグレードや特殊タイプの屋根は含まれません。'
            }
          }
        },
        storage: {
          indicativePricing: 'kWhあたりの参考価格帯',
          indicativePricingStorageSlabs: 'kWhあたりの参考価格',
          main: '蓄電池 - 設置',
          quoteSizeIn: 'kWh',
          sub: '新しい蓄電池システムの設置',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub:
                'ターンキー価格を提供し、IQ Battery蓄電池、IQ System Controllerスイッチ、セルラー・モデム、アクセサリ・キット、ケーブルなど、必要なすべての部品表を調達します。.'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯にはメインパネルのアップグレードは含まれません。`
            }
          }
        },
        microinverter: {
          indicativePricing: '1ワットあたりの参考価格帯',
          main: 'マイクロインバーター - アップグレード',
          quoteSizeIn: 'kW',
          sub:
            'Mシリーズ（M-215、M-250など）ベースのソーラーシステムから新しいIQベースのソーラーシステム（通常「蓄電池設置」を伴う）へのMicroinverter upgrade',
          sub2:
            'Mシリーズ（M-215、M-250など）ベースのソーラーシステムから新しいIQベースのソーラーシステムへのMicroinverter upgrade',
          subUS: '既存のソーラーシステムを新しいIQベースのソーラーシステムに変換するためのMicroinverter upgrade',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub: 'ターンキー価格を提供し、必要な部品表をすべて調達します。'
            },
            assumptions: {
              main: '前提条件',
              sub: '参考価格帯には、メインパネルのアップグレードとソーラーパネルのアップグレードは含まれません。'
            }
          }
        }
      },
      installationOnly: {
        title: '設置のみのサービス（特別プログラム用）',
        titleUS: '設置のみのサービス',
        sub: '(例：M-190ベースのソーラーパネルをお持ちの住宅所有者、Enphaseの友人および家族）',
        description:
          '設置のみのサービスとは、住宅所有者がEnphase StoreからEnphaseの部品表を調達することを意味します。その他の材料やサービスはすべて、設置業者によって直接提供されます（配線、架台、設計、許可、設置、試運転（該当する場合））。',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'ワットあたりの設置のみの参考価格帯',
          main: 'ソーラー - 設置',
          sub: 'M-190/M-210/M-175/D380ベースのソーラーシステムの特別プログラムまたはフルアップグレードのための新規設置',
          subUS: '新しいソーラーシステムの設置',
          details: {
            homeOwner: {
              main: '住宅所有者',
              sub:
                'Enphaseから必要な部品表を購入します ACモジュール、IQ Combinerボックス、アクセサリーキット、サーキットブレーカーなどを保管します。'
            },
            installer: {
              main: '設置業者',
              sub: '架台、配線、許可、設置、試運転を提供します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯には、メインパネルのアップグレードと特殊ルーフの設置は含まれません。.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'kWhあたりの設置のみの参考価格帯',
          indicativePricingStorageSlabs: 'kWhあたりの設置のみの参考価格',
          main: '蓄電池 - 設置',
          sub:
            '特別プログラム用、またはM-190/M-210/M-175/D380ベースのソーラーシステム用に、既存のソーラーシステムに蓄電池を追加',
          subUS: '新しい蓄電池システムの設置',
          details: {
            homeOwner: {
              main: '住宅所有者',
              sub:
                'Enphaseから必要な部品表を購入します IQ Battery蓄電池、Enpowerスイッチ、アクセサリーキット、Gateway（必要に応じてIQ Combinerボックス、セルラーモデム、Consumption CT）など保管します.'
            },
            installer: {
              main: '設置業者',
              sub: '許可、設置、試運転を提供します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯にはメインパネルのアップグレードは含まれません。`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'ワットあたりの設置のみの参考価格帯',
          main: 'マイクロインバーター - アップグレード',
          sub: `M-190/M-210/M-175/D380ベースのソーラーシステムから新しいIQベースのソーラーシステム（通常「蓄電池設置」を伴う）へのMicroinverter upgrade`,
          sub2:
            'Mシリーズ（M-215、M-250など）ベースのソーラーシステムから新しいIQベースのソーラーシステムへのMicroinverter upgrade',
          subUS: '既存のソーラーシステムを新しいIQベースのソーラーシステムに変換するためのMicroinverter upgrade',
          details: {
            homeOwner: {
              main: '住宅所有者',
              sub:
                'Enphaseから必要な部品表を購入します マイクロインバーター、IQ Combinerボックス、アクセサリーキット、サーキットブレーカーなどを保管します。'
            },
            installer: {
              main: '設置業者',
              sub: '古いマイクロインバーターの許可、交換、再運転、リサイクルを提供します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯には、メインパネルのアップグレードと架台の変更は含まれません。`
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&Mサービス',
        om: {
          main: 'Enphase O&Mサービスのオプトイン',
          pre: '- オーファンシステムを含む',
          sub: `オペレーションとメンテナンス (O&M) サービスには、既存のEnphaseシステムと、オーファンシステム (設置業者が今ではアクティブではないサイト) のサポートとメンテナンスが含まれます。すべてのO&Mリードには、サイトの詳細とサポート履歴が提供されます。すべての O&M リードには、Enphase 標準製品保証が適用されます。オーファンシステムには、以前の製造保証は適用されません。`
        }
      },
      otherServices: {
        title: 'その他の設定',
        buy: '製品の購入を希望します',
        acModule: {
          main: 'Enphase Energized ACモジュールの設置を希望します',
          sub1: `Enphase Energized ACモジュール `,
          sub2: `は、Enphaseの最新のマイクロインバータ技術と高効率ソーラーパネルを組み合わせたものです。インバーターとパネルを一体化することで設置時間を短縮し、美観と性能を兼ね備えたエレガントな製品です。このオプションを選択すると、EnphaseはACモジュールの設置を希望している住宅所有者と貴社をマッチングします。`
        },
        enstore: {
          main: 'Enphase Store',
          sub1: `Enphase Store `,
          sub2: `は、配送保証付きのソーラーおよび蓄電池製品の総合ショップです。Storeでは最低注文数量は必要なく、リアルタイムでの配送とオンライン追跡を提供しています。`,
          subIndia: `は、配達保証付きのソーラー製品の総合ショップです。Storeでは最低注文数量は必要なく、リアルタイムでの配送とオンライン追跡を提供しています。`
        },
        distributor: {
          main: 'Enphase販売業者',
          sub1: `Enphase販売業者`,
          sub2: ` は、貴社のソーラー＆蓄電池ソリューションに必要なすべてのEnphase製品およびその他のアクセサリーを提供します`,
          subIndia: ` は、貴社のソーラーソリューションに必要なすべてのEnphase製品およびその他のアクセサリーを提供します`
        },
        permitAssistance: {
          main: 'Enphaseの許可支援サービスに興味があります',
          sub: `Enphaseは、貴社が自治体に提出し認可を受けることができるよう、貴社のサイトに応じたソーラーおよび蓄電池許可パッケージをサポートします。`
        },
        financeProvider: {
          // TODO - new translations added
          main: '住宅所有者向けの融資オプションを提供しています',
          // TODO ends
          no: 'いいえ',
          yes: 'はい',
          financeProvider: 'ファイナンス・プロバイダー',
          others: 'その他のプロバイダー',
          addMultiple: '3つまで（コンマで区切る）',
          requiredSelection: '必須の選択',
          atLeastOneError: `無効なファイナンス・プロバイダー（「その他のプロバイダー」を選択した場合は、少なくともプロバイダー名を1つ入力してください。）`
        }
      },
      serviceArea: {
        name: 'サービスエリアの追加',
        sub: '追加されたエリアはありません',
        description: `サービスエリアを追加してください。これは、Enphaseがお客様と住宅所有者のリードをマッチングするために必要です。`
      },
      qualifyLeads: {
        mainSection:
          'リードを共有する前に、Enphaseの担当者による電話でのリードの適格性確認を希望しますか？',
        moreInfo: 'リードについて収集してほしい特定の情報がありましたらお知らせください。',
        infoWeCollect: '資格認定プロセスの一環として、当社がどのような情報を収集しているかを知るため',
        subSection:
          '資格認定後、住宅所有者が当社と電話をしている間に、リードを貴社の担当者に転送することを希望しますか？',
        details: 'リードを転送する貴社の管理ユーザーを1名お選びください。',
        icCheckList: '資格チェックリスト',
        selectOption: 'オプションを選択してください',
        selectUser: 'ユーザーを選択してください'
      }
    },
    textContentAu: {
      preference: {
        title: 'Leads Programの設定',
        caption: '免責事項',
        description: `Enphaseは、住宅所有者に対して、以下の各希望に対して提供された価格範囲を表示します。この価格設定は予算的なものであり、典型的なシステムの作業範囲のみを反映したものであるという免責事項とともに表示されます。実際の価格は、場所、屋根のタイプ/ピッチ、電気パネルのアップグレード、システムの別の場所への移設によって変更される場合があります。`,
        atleaseOne: `* 少なくとも1つのサービスを選択`
      },
      programreview: {
        title: 'プログラム概要',
        description: `住宅オーナーは、新規設置、アップグレード、継続的なシステムメンテナンスのために Enphase に連絡します。Enphaseのパートナーには、Enphase Leads Programを通じて、このような住宅所有者にサービスを提供する機会があります。以下の主要条件をご確認の上、このプログラムに対するご希望をご指定ください。`
      },
      keyProgramTerms: {
        title: 'プログラムの主要条件',
        enphaseProduct: 'プログラムの一環として、Enphase製品のみを使用すること',
        appointment: 'Enphaseは、予約のスケジューリングをサポートし、必要に応じてその他のサポートを提供します',
        contact: '設置業者は、2営業日以内に各リードに連絡することが期待されています',
        project: '最初の交渉の前に、顧客プロファイルとプロジェクトの詳細を各リードに提供します',
        verifiedAccount: 'Enphase は、お客様のサービスエリアから適格なリードを無料で提供します'
      },
      TurnKey: {
        title: 'ターンキーサービス',
        description: `ターンキーサービスとは、部品表、システムの設計、許可、設置、および試運転（該当する場合）を提供することを意味します。設置業者は、詳細な見積もりを提示する前に、プロジェクトと現場の査定を行います。 表示価格には、システムを作動させるために住宅所有者が負担する見積もり費用の合計を含める必要があります`,
        solar: {
          indicativePricing: '1ワットあたりの参考価格帯',
          quoteSizeIn: 'kW',
          main: 'ソーラー - 設置',
          sub: '新しいソーラーシステムの設置。',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub:
                'ターンキー価格を提供し、モジュール、マイクロインバーター、アクセサリー、サーキットブレーカー、セルラーモデム、ケーブル、架台など、必要なすべての部品表を調達します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `価格帯は一般的な敷地のもので、メインパネルのアップグレードや特殊タイプの屋根は含まれません。`
            }
          }
        },
        storage: {
          indicativePricing: 'kWhあたりの参考価格帯',
          main: '蓄電池 - 設置',
          quoteSizeIn: 'kWh',
          sub: '新しい蓄電池システムの設置',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub:
                'ターンキー価格を提供し、ACB蓄電池、ブラケット、配線、サーキットブレーカーなど、必要なすべての部品表を調達します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯にはメインパネルのアップグレードは含まれません。`
            }
          }
        },
        microinverter: {
          indicativePricing: '1ワットあたりの参考価格帯',
          main: 'マイクロインバーター - アップグレード',
          quoteSizeIn: 'kW',
          sub:
            'Mシリーズ（M-215、M-250など）ベースのソーラーシステムから新しいIQベースのソーラーシステム（通常「蓄電池設置」を伴う）へのMicroinverter upgrade',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub: 'ターンキー価格を提供し、必要な部品表をすべて調達します。'
            },
            assumptions: {
              main: '前提条件',
              sub: '参考価格帯には、メインパネルのアップグレードとソーラーパネルのアップグレードは含まれません。'
            }
          }
        },
        solarExpansion: {
          indicativePricing: '1ワットあたりの参考価格帯',
          quoteSizeIn: 'kW',
          main: 'ソーラーシステムの拡張',
          sub: '既存のEnphaseおよびEnphase以外のソーラーシステムの拡張',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: '設置業者',
              sub: 'ターンキー価格を提供し、必要な部品表をすべて調達します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `価格帯は一般的な敷地のもので、メインパネルのアップグレードや特殊タイプの屋根は含まれません。`
            }
          }
        }
      },
      installationOnly: {
        title: '設置のみのサービス（特別プログラム用）',
        sub: '(例：オーファンシステムの交換/修理、バッテリーのアップグレード、Gatewayのアップグレードなど）',
        description:
          '設置のみのサービスとは、住宅所有者がEnphase StoreからEnphaseの部品表を調達することを意味します。その他の材料やサービスはすべて、設置業者によって直接提供されます（配線、架台、設計、許可、設置、試運転（該当する場合））。',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'ワットあたりの設置のみの参考価格帯',
          main: 'ソーラー - 設置',
          sub: `Enphaseの顧客、設置業者、従業員からの紹介リードなどの特別プログラムのための新規設置。`,
          details: {
            homeOwner: {
              main: '住宅所有者',
              sub: `マイクロインバーター、アクセサリーキット、Gateway、サーキットブレーカーなど、必要な部品表をEnphase Storeから購入します。`
            },
            installer: {
              main: '設置業者',
              sub: 'モジュール、架台、配線、許可、設置、試運転を提供します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯には、メインパネルのアップグレードと特殊ルーフの設置は含まれません。.`
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'kWhあたりの設置のみの参考価格帯',
          main: '蓄電池 - 拡張または設置',
          sub: '特別プログラムのためのACB蓄電池の拡張または既存のソーラーシステムへの設置',
          details: {
            homeOwner: {
              main: '住宅所有者',
              sub: 'Enphaseから必要な部品表を購入します ACB蓄電池、ブラケットなどを保管します.'
            },
            installer: {
              main: '設置業者',
              sub: '設置および試運転を提供します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯にはメインパネルのアップグレードは含まれません。`
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'ワットあたりの設置のみの参考価格帯',
          main: 'マイクロインバーター - アップグレード',
          sub: `M-190/M-210/M-175/D380ベースのソーラーシステムから新しいIQベースのソーラーシステム（通常「蓄電池設置」を伴う）へのMicroinverter upgrade`,
          details: {
            homeOwner: {
              main: '住宅所有者',
              sub:
                'Enphaseから必要な部品表を購入します マイクロインバーター、IQ Combinerボックス、アクセサリーキット、サーキットブレーカーなどを保管します。'
            },
            installer: {
              main: '設置業者',
              sub: '古いマイクロインバーターの許可、交換、再運転、リサイクルを提供します。'
            },
            assumptions: {
              main: '前提条件',
              sub: `参考価格帯には、メインパネルのアップグレードと架台の変更は含まれません。`
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&Mサービス',
        om: {
          main: 'Enphase O&Mサービスのオプトイン',
          pre: '- オーファンシステムを含む',
          sub: `オペレーションとメンテナンス (O&M) サービスには、既存のEnphaseシステムと、オーファンシステム (設置業者が今ではアクティブではないサイト) のサポートとメンテナンスが含まれます。すべてのO&Mリードには、サイトの詳細とサポート履歴が提供されます。すべての O&M リードには、Enphase 標準製品保証が適用されます。`
        }
      },
      otherServices: {
        title: 'その他の設定',
        buy: '製品の購入を希望します',
        acModule: {
          main: 'Enphase Energized ACモジュールの設置を希望します',
          sub1: `Enphase Energized ACモジュール `,
          sub2: `は、Enphaseの最新のマイクロインバータ技術と高効率ソーラーパネルを組み合わせたものです。インバーターとパネルを一体化することで設置時間を短縮し、美観と性能を兼ね備えたエレガントな製品です。このオプションを選択すると、EnphaseはACモジュールの設置を希望している住宅所有者と貴社をマッチングします。`
        },
        enstore: {
          main: 'Enphase Store',
          sub1: `Enphase Store `,
          sub2: `は、配送保証付きのソーラーおよび蓄電池製品の総合ショップです。Storeでは最低注文数量は必要なく、リアルタイムでの配送とオンライン追跡を提供しています。`
        },
        distributor: {
          main: 'Enphase販売業者',
          sub1: `Enphase販売業者`,
          sub2: ` は、貴社のソーラー＆蓄電池ソリューションに必要なすべてのEnphase製品およびその他のアクセサリーを提供します`
        }
      },
      serviceArea: {
        name: 'サービスエリアの追加',
        sub: '追加されたエリアはありません',
        description: `サービスエリアを追加してください。これは、Enphaseがお客様と住宅所有者のリードをマッチングするために必要です。`
      }
    },
    getLink: `リンクを取得`,
    linkSENewLeads: `新規リード用システム見積もりリンク`,
    shareSELink: `このリンクをお客様と共有し、Enphaseシステムのサイズを見積もり、詳細を送信していただくことで、Enlighten Managerでリードを獲得してください`
  }
};

export default leadPreferences;
